import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import SensorSetting from "pages/management/setting/iot/sensor";
import SensorViewSetting from "pages/management/setting/iot/sensor-view";

export default function MonitoringSettingSensorRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <SensorSetting /> }/>
                
                <Route path=":id" element={ <SensorViewSetting /> }/>
                
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}